export const TASK_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    ON_HOLD: 'on_hold',
    COMPLETED: 'completed',
};

export const TASK_STATUS_OPTIONS = [
    { value: TASK_STATUS.NOT_STARTED, label: 'Not Started' },
    { value: TASK_STATUS.IN_PROGRESS, label: 'In Progress' },
    { value: TASK_STATUS.ON_HOLD, label: 'On Hold' },
    { value: TASK_STATUS.COMPLETED, label: 'Completed' },
];
